import { toast } from 'sonner'

import { Button } from '@/components/ui/button'
import { ConfirmationDialog } from '@/components/ui/confirmation-dialog'
import { useWithdrawClaim } from '@/models/claim'

/** Closes the claim as withdrawn. Offered once it is submitted — a draft is edited instead. */
export function WithdrawClaimButton({
  claimId,
  idShort,
  orgId,
}: {
  claimId: string
  idShort: string
  /** Set when staff withdraw for a customer, so the write is scoped to their org. */
  orgId?: string
}) {
  const withdraw = useWithdrawClaim(orgId)

  return (
    <ConfirmationDialog
      title={`Withdraw claim ${idShort}?`}
      description={
        orgId
          ? 'This closes the claim as withdrawn on the customer’s behalf. Only staff can reopen it.'
          : 'This closes the claim as withdrawn. Your broker will see it on their next look, so call them if work needs to stop today. You cannot undo this yourself.'
      }
      confirmLabel="Withdraw claim"
      onConfirm={async () => {
        try {
          await withdraw.mutateAsync(claimId)
          toast.success('Claim withdrawn.')
        } catch {
          toast.error('Could not withdraw the claim.')
        }
      }}
    >
      <Button variant="link" size="sm" className="h-auto px-0">
        Withdraw
      </Button>
    </ConfirmationDialog>
  )
}
